import { gql } from "graphql-request";

export const NextGenCustomFieldsFragment = gql`
  fragment NextGenCustomFieldsFragment on NextGenCustomReportSearchResult {
    nextGenReportId
    name
    subdomain
  }
`;
